"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.remarkMdxFrontmatter = void 0;

var estree_util_is_identifier_name_1 = require("estree-util-is-identifier-name");

var estree_util_value_to_estree_1 = require("estree-util-value-to-estree");

var js_yaml_1 = require("js-yaml");

var toml_1 = require("toml");
/**
 * A remark plugin to expose frontmatter data as named exports.
 *
 * @param options - Optional options to configure the output.
 * @returns A unified transformer.
 */


var remarkMdxFrontmatter = function remarkMdxFrontmatter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      name = _ref.name;

  return function (ast) {
    var _mdast$children;

    var mdast = ast;
    var imports = [];

    if (name && !(0, estree_util_is_identifier_name_1.name)(name)) {
      throw new Error("If name is specified, this should be a valid identifier name, got: ".concat(JSON.stringify(name)));
    }

    var _iterator = _createForOfIteratorHelper(mdast.children),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var node = _step.value;
        var data = void 0;
        var value = node.value;

        if (node.type === 'yaml') {
          data = (0, js_yaml_1.load)(value); // @ts-expect-error A custom node type may be registered for TOML frontmatter data.
        } else if (node.type === 'toml') {
          data = (0, toml_1.parse)(value);
        }

        if (data == null) {
          continue;
        }

        if (!name && typeof data !== 'object') {
          throw new Error("Expected frontmatter data to be an object, got:\n".concat(value));
        }

        imports.push({
          type: 'mdxjsEsm',
          value: '',
          data: {
            estree: {
              type: 'Program',
              sourceType: 'module',
              body: [{
                type: 'ExportNamedDeclaration',
                source: null,
                specifiers: [],
                declaration: {
                  type: 'VariableDeclaration',
                  kind: 'const',
                  declarations: Object.entries(name ? _defineProperty({}, name, data) : data).map(function (_ref3) {
                    var _ref4 = _slicedToArray(_ref3, 2),
                        identifier = _ref4[0],
                        val = _ref4[1];

                    if (!(0, estree_util_is_identifier_name_1.name)(identifier)) {
                      throw new Error("Frontmatter keys should be valid identifiers, got: ".concat(JSON.stringify(identifier)));
                    }

                    return {
                      type: 'VariableDeclarator',
                      id: {
                        type: 'Identifier',
                        name: identifier
                      },
                      init: (0, estree_util_value_to_estree_1.valueToEstree)(val)
                    };
                  })
                }
              }]
            }
          }
        });
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    (_mdast$children = mdast.children).unshift.apply(_mdast$children, imports);
  };
};

exports.remarkMdxFrontmatter = remarkMdxFrontmatter;